import { render, staticRenderFns } from "./CopyCode.vue?vue&type=template&id=4d17814d&scoped=true&"
import script from "./CopyCode.vue?vue&type=script&lang=js&"
export * from "./CopyCode.vue?vue&type=script&lang=js&"
import style0 from "./CopyCode.vue?vue&type=style&index=0&id=4d17814d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d17814d",
  null
  
)

export default component.exports